module.exports = __webpack_public_path__ + "seasonal_summer-pop_1.jpg";